import styles from './TextField.styles.scss';
export const inputFieldDefinition = (baseName, template) => ({
    baseName,
    template,
    styles,
    shadowOptions: {
        delegatesFocus: true,
    },
});
